import queryString from 'query-string';
import { apiFetch } from './utils/api';

// eslint-disable-next-line no-unused-vars
const mockedPortfolioLenses = require('./mocks/v3/portfolio-lenses.json');

export const portfolioLenses = {
  get: async (args) => {
    //return mockedPortfolioLenses;
    const options = {
      method: 'GET',
    };

    const query = queryString.stringify(args, { arrayFormat: 'comma' });
    const url = `v3/portfolio/portfolio-lenses?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
